(function () {
  var USDA_URL = 'https://planthardiness.ars.usda.gov/';

  var zoneTempMap = {
    '1a': '-60 to -55°F',
    '1b': '-55 to -50°F',
    '2a': '-50 to -45°F',
    '2b': '-45 to -40°F',
    '3a': '-40 to -35°F',
    '3b': '-35 to -30°F',
    '4a': '-30 to -25°F',
    '4b': '-25 to -20°F',
    '5a': '-20 to -15°F',
    '5b': '-15 to -10°F',
    '6a': '-10 to -5°F',
    '6b': '-5 to 0°F',
    '7a': '0 to 5°F',
    '7b': '5 to 10°F',
    '8a': '10 to 15°F',
    '8b': '15 to 20°F',
    '9a': '20 to 25°F',
    '9b': '25 to 30°F',
    '10a': '30 to 35°F',
    '10b': '35 to 40°F',
    '11a': '40 to 45°F',
    '11b': '45 to 50°F',
    '12a': '50 to 55°F',
    '12b': '55 to 60°F',
    '13a': '60 to 65°F',
    '13b': '65 to 70°F'
  };

  var zipDb = null;
  var zipDbPromise = null;

  function normalizeZip(zip) {
    var raw = String(zip || '').trim();
    var digits = raw.replace(/\D/g, '');
    return digits.length === 5 ? digits : '';
  }

  function zipCandidates(zip) {
    var clean = normalizeZip(zip);
    if (!clean) return [];

    var list = [clean];
    var noLeading = String(parseInt(clean, 10));

    if (noLeading && noLeading !== 'NaN' && list.indexOf(noLeading) === -1) {
      list.push(noLeading);
    }

    return list;
  }

  function normalizeZone(zone) {
    if (!zone && zone !== 0) return '';

    var value = String(zone)
      .toLowerCase()
      .replace(/usda/gi, '')
      .replace(/plant hardiness/gi, '')
      .replace(/growing/gi, '')
      .replace(/zone/gi, '')
      .replace(/\s+/g, '')
      .trim();

    var match = value.match(/^(\d{1,2})([ab])?$/);
    if (!match) return '';

    return match[1] + (match[2] || '');
  }

  function formatZoneLabel(zone) {
    var z = normalizeZone(zone);
    if (!z) return '';

    var match = z.match(/^(\d{1,2})([ab])?$/);
    return match ? match[1] + (match[2] || '') : '';
  }

  function wholeZoneLabel(zone) {
    var z = normalizeZone(zone);
    var match = z.match(/^(\d{1,2})/);
    return match ? match[1] : '';
  }

  function shopCollectionUrl(zone) {
    var wholeZone = wholeZoneLabel(zone);

    var map = {
      '3': '/collections/usda-zone-3',
      '4': '/collections/zone-4',
      '5': '/collections/zone-5',
      '6': '/collections/zone-6',
      '7': '/collections/usda-zone-7',
      '8': '/collections/usda-zone-8',
      '9': '/collections/usda-zone-9',
      '10': '/collections/usda-zone-10'
    };

    return map[wholeZone] || '/collections/all';
  }

  function extractEntryValue(entry, keys) {
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (entry && entry[key] != null && entry[key] !== '') {
        return entry[key];
      }
    }
    return '';
  }

  function normalizeEntry(entry) {
    if (entry == null) return null;

    if (typeof entry === 'string' || typeof entry === 'number') {
      var zoneFromValue = normalizeZone(entry);
      return zoneFromValue ? { zone: zoneFromValue, temp: zoneTempMap[zoneFromValue] || '' } : null;
    }

    if (typeof entry !== 'object') return null;

    var zone = extractEntryValue(entry, [
      'zone',
      'Zone',
      'usda_zone',
      'usdaZone',
      'hardiness_zone',
      'hardinessZone',
      'growing_zone',
      'growingZone',
      'zone_name',
      'zoneName',
      'value'
    ]);

    var temp = extractEntryValue(entry, [
      'temp',
      'Temp',
      'temperature',
      'range',
      'temp_range',
      'tempRange'
    ]);

    var cleanZone = normalizeZone(zone);

    if (!cleanZone) return null;

    return {
      zone: cleanZone,
      temp: temp || zoneTempMap[cleanZone] || ''
    };
  }

  function buildZipDb(rawData) {
    var built = {};

    if (!rawData) return built;

    var data = rawData;
    if (rawData.data) data = rawData.data;
    if (rawData.zips) data = rawData.zips;
    if (rawData.records) data = rawData.records;

    if (Array.isArray(data)) {
      for (var i = 0; i < data.length; i++) {
        var row = data[i];
        if (!row || typeof row !== 'object') continue;

        var zip = extractEntryValue(row, [
          'zip',
          'ZIP',
          'zipcode',
          'zip_code',
          'postal_code',
          'postalCode'
        ]);

        var cleanZip = normalizeZip(zip);
        var cleanEntry = normalizeEntry(row);

        if (cleanZip && cleanEntry) {
          built[cleanZip] = cleanEntry;
        }
      }
      return built;
    }

    if (typeof data === 'object') {
      Object.keys(data).forEach(function (key) {
        var cleanZip = normalizeZip(key);
        var cleanEntry = normalizeEntry(data[key]);

        if (cleanZip && cleanEntry) {
          built[cleanZip] = cleanEntry;
        }
      });
    }

    return built;
  }

  function getZipEntry(db, zip) {
    var candidates = zipCandidates(zip);

    for (var i = 0; i < candidates.length; i++) {
      var candidate = candidates[i];
      if (db[candidate]) return db[candidate];
    }

    return null;
  }

  function loadZipDb() {
    if (zipDb) return Promise.resolve(zipDb);
    if (zipDbPromise) return zipDbPromise;
    if (!window.GPF_ZIP_DB_URL) return Promise.reject(new Error('Missing GPF_ZIP_DB_URL'));

    zipDbPromise = fetch(window.GPF_ZIP_DB_URL, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('ZIP database failed to load');
        return res.json();
      })
      .then(function (data) {
        zipDb = buildZipDb(data);
        return zipDb;
      });

    return zipDbPromise;
  }

  function showResult(result, type, html) {
    result.style.display = 'block';
    result.innerHTML = html;

    if (type === 'error') {
      result.style.background = '#fef2f2';
      result.style.borderColor = '#fecaca';
      result.style.color = '#991b1b';
      return;
    }

    if (type === 'warn') {
      result.style.background = '#fffbeb';
      result.style.borderColor = '#fde68a';
      result.style.color = '#92400e';
      return;
    }

    result.style.background = '#e8f5ea';
    result.style.borderColor = '#bfe3ca';
    result.style.color = '#0f5132';
  }

  function renderZipMatch(result, zip, entry) {
    var zone = entry && entry.zone ? formatZoneLabel(entry.zone) : '';
    var temp = entry && entry.temp ? entry.temp : '';

    if (!zone) {
      showResult(
        result,
        'warn',
        'ZIP ' + zip + ' was found, but the zone record is incomplete. ' +
        '<a href="' + USDA_URL + '" target="_blank" rel="noopener">Check on USDA →</a>'
      );
      return;
    }

    if (!temp) {
      temp = zoneTempMap[normalizeZone(zone)] || '';
    }

    var wholeZone = wholeZoneLabel(zone);
    var collectionUrl = shopCollectionUrl(zone);
    var tempText = temp ? ' (' + temp + ')' : '';

    showResult(
      result,
      'ok',
      '📍 ZIP ' + zip + ' → <strong>Zone ' + zone + '</strong>' + tempText +
      ' &nbsp;&mdash;&nbsp; <a href="' + collectionUrl + '">Shop Zone ' + wholeZone + ' plants →</a>'
    );
  }

  function initZonePage(root) {
    var input = root.querySelector('.gpf-zip-input');
    var button = root.querySelector('.gpf-zip-btn');
    var result = root.querySelector('.gpf-zip-result');

    if (!input || !button || !result) return;

    function lookupZip() {
      var zip = normalizeZip(input.value || '');

      if (!zip) {
        showResult(result, 'error', 'Please enter a valid 5-digit ZIP code.');
        return;
      }

      button.disabled = true;
      button.textContent = 'Looking...';

      loadZipDb()
        .then(function (db) {
          var entry = getZipEntry(db, zip);

          if (entry) {
            renderZipMatch(result, zip, entry);
            return;
          }

          showResult(
            result,
            'warn',
            'ZIP ' + zip + ' was not found in the local database. ' +
            '<a href="' + USDA_URL + '" target="_blank" rel="noopener">Check on the official USDA map →</a>'
          );
        })
        .catch(function () {
          showResult(
            result,
            'warn',
            'The ZIP database is temporarily unavailable. ' +
            '<a href="' + USDA_URL + '" target="_blank" rel="noopener">Check on the official USDA map →</a>'
          );
        })
        .finally(function () {
          button.disabled = false;
          button.textContent = 'Look Up';
        });
    }

    button.addEventListener('click', lookupZip);

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        lookupZip();
      }
    });
  }

  function init() {
    var pages = document.querySelectorAll('.gpf-zone-page');
    if (!pages.length) return;
    pages.forEach(initZonePage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();